export const HIDE_SERVICE_INTERNAL_ID = 'hide_service';
export const HIDE_RETURN_INTERNAL_ID = 'hide_return';
export const DISABLE_COMPARISONS_INTERNAL_ID = 'disable_product_comparisons';
export const ENABLE_STICKY_PRODUCT_INFO_INTERNAL_ID = 'enable_sticky_product_info';
export const SPR_127_CERTIFICATES_INTERNAL_ID = 'spr_127_certificates';

export const experimentsConfig = [
  {
    name: HIDE_SERVICE_INTERNAL_ID,
    groups: [{ name: 'A', weight: 1 }],
    trafficPercentRange: 1,
  },
  {
    name: HIDE_RETURN_INTERNAL_ID,
    groups: [{ name: 'A', weight: 1 }],
    trafficPercentRange: 1,
  },
];
